import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { CardFormComponent } from './cardform.component';

const routes: Routes = [
  { path: '', component: CardFormComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CardFormRoutingModule { }
